<template>
  <div  :class="['wrapper',{ 'nav-open': $sidebar.showSidebar }]">
    <notifications></notifications>
    <side-bar>
      <template slot-scope="props" slot="links">
        <sidebar-item v-if="isCurrentAdmin || canViewReport || isAdminTI"
          :link="{ name: 'Dashboard', icon: 'dashboard', path: '/dashboard' }"></sidebar-item>
        <sidebar-item v-if="isCurrentAdmin || isAdminTI" :link="{
          name: 'Review Reference',
          path: '/review-reference',
          icon: 'list',
        }"></sidebar-item>
        <sidebar-item :link="{
          name: 'Reviews',
          icon: 'question_answer',
          path: actualRoute('/reviews/list'),
        }"></sidebar-item>
        <sidebar-item v-if="isCurrentAdmin || isAdminTI" :link="{
          name: 'Questionnaires',
          path: actualRoute('/questionnaires/list'),
          icon: 'textsms',
        }"></sidebar-item>
        <sidebar-item v-if="isCurrentAdmin || isAdminTI" :link="{ name: 'Questions', path: '/questions', icon: 'help' }">
        </sidebar-item>
        <sidebar-item v-if="isCurrentAdmin || isAdminTI" :link="{ name: 'Clusters', path: '/clusters', icon: 'label' }">
        </sidebar-item>
        <sidebar-item v-if="isCurrentAdmin || canViewReport || isAdminTI" :link="{ name: 'Reports', icon: 'done_all' }">
          <sidebar-item :link="{ name: 'Review Results', path: actualRoute('/report/review/list') }"></sidebar-item>
          <sidebar-item :link="{ name: 'Remediation Action Report', path: '/report/remediation-action/' }"></sidebar-item>
          <sidebar-item v-if="!isAdminTI" :link="{ name: 'General Report', path: '/report/reviews-excel' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item v-if="isCurrentAdmin || isAdminTI" :link="{ name: 'Users Admin', path: '/rq-team', icon: 'people' }">
        </sidebar-item>
        <sidebar-item v-if="isCurrentAdmin || isAdminTI" :link="{
          name: 'Action Plans',
          path: '/action-plans',
          icon: 'analytics',
        }"></sidebar-item>
        <sidebar-item v-if="isCurrentAdmin || isAdminTI" :link="{ name: 'Emails', path: '/emails', icon: 'email' }">
        </sidebar-item>
      </template>
    </side-bar>
    <div :class="'main-panel'">
      <top-navbar></top-navbar>

      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import { SlideYDownTransition, ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    SlideYDownTransition,
    ZoomCenterTransition,
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    actualRoute(route) {
      if (this.$route.path.includes(route)) {
        return this.$route.path
      }
      return `${route}/1`
    },
  },

  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },

    isCurrentAdmin() {
      return this.$store.state.currentProfile === "admin"
    },

    isReviewer() {
      return this.$store.state.currentProfile === "reviewer";
    },

    isRQRLeader() {
      return this.$store.state.currentProfile === "rqr_leader";
    },

    isAdminTI() {
      return this.$store.state.currentProfile === "adminTi";
    },

    isAudit() {
      return this.$store.state.currentProfile === "audit";
    },

    canViewReport() {
      return this.isReviewer || this.isRQRLeader;
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
